import { database, ref, push, set, onValue, off, remove } from '../../pages/Auth/db/firebase';

// Send help notification to super admin with date-based organization
export const sendHelpNotification = async (notificationData) => {
  try {
    const today = new Date();
    const dateKey = today.toISOString().split('T')[0]; // YYYY-MM-DD format
    
    const notificationRef = ref(database, `notifications/help_requests/${dateKey}`);
    const newNotificationRef = push(notificationRef);
    
    await set(newNotificationRef, {
      ...notificationData,
      id: newNotificationRef.key,
      type: 'help_request',
      status: 'unread',
      createdAt: new Date().toISOString(),
      dateKey,
    });

    return newNotificationRef.key;
  } catch (error) {
    console.error('Failed to send help notification:', error);
    throw error;
  }
};

// Send general notification to super admin
export const sendNotificationToSuperAdmin = async (notificationData) => {
  try {
    const notificationRef = ref(database, 'notifications/general');
    const newNotificationRef = push(notificationRef);
    
    await set(newNotificationRef, {
      ...notificationData,
      id: newNotificationRef.key,
      status: 'unread',
      createdAt: new Date().toISOString(),
    });

    return newNotificationRef.key;
  } catch (error) {
    console.error('Failed to send notification:', error);
    throw error;
  }
};

// Listen to help requests (for super admin) - now with date structure
export const listenToHelpRequests = (callback) => {
  const helpRequestsRef = ref(database, 'notifications/help_requests');
  
  const listener = onValue(helpRequestsRef, (snapshot) => {
    const requests = [];
    if (snapshot.exists()) {
      const data = snapshot.val();
      
      // Iterate through date keys first
      Object.keys(data).forEach(dateKey => {
        const dateRequests = data[dateKey];
        Object.keys(dateRequests).forEach(requestKey => {
          requests.push({ 
            key: requestKey, 
            dateKey,
            ...dateRequests[requestKey] 
          });
        });
      });
    }
    callback(requests);
  });

  return () => off(helpRequestsRef, 'value', listener);
};

// Mark notification as read (completely delete it from database)
export const markNotificationAsRead = async (notificationType, notificationId, dateKey) => {
  try {
    const notificationRef = ref(database, `notifications/${notificationType}/${dateKey}/${notificationId}`);
    await remove(notificationRef);
  } catch (error) {
    console.error('Failed to mark notification as read:', error);
    throw error;
  }
};

// Get unread notification count
export const getUnreadNotificationCount = (notifications) => {
  return notifications.filter(notification => notification.status === 'unread').length;
};
